import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=858e62f2"
import script from "./Placeholder.vue?vue&type=script&lang=ts"
export * from "./Placeholder.vue?vue&type=script&lang=ts"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=858e62f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports